<template>
    <div class="messages">
        <div class="mt-4 pt-1 pb-3">
            <p class="text-left font-italic ml-2">Messages</p>
            <div class="bg-light border add-rounded py-2 px-4">
                <div class="">
                    <div class="row">
                        <img src="../assets/kovatek/Mask Group 46.svg" alt="" class="rounded-circle img-height" />
                        <div class="col">
                            <h6 class="kova-text text-left font-weight-bolder mt-2">Sun Yeoun W</h6>
                            <p class="text-left text-dark font-weight-lighter mb-0 pb-0 ctrl-size-2">Wordpress login, from username to username email and phone number... <span class="ant-color">see more</span> </p>
                        </div>
                        </div>
                        <p class="text-right text-dark font-weight-bolder ctrl-size"><font-awesome-icon class="kova-text ctrl-size" icon="clock" /> 30 minutes ago</p>
                    <hr />
                </div>
                <div class="">
                    <div class="row">
                        <img src="../assets/kovatek/Mask Group 46.svg" alt="" class="rounded-circle img-height" />
                        <div class="col">
                            <h6 class="kova-text text-left font-weight-bolder mt-2">Sun Yeoun W</h6>
                            <p class="text-left text-dark font-weight-lighter mb-0 pb-0 ctrl-size-2">Wordpress login, from username to username email and phone number... <span class="ant-color">see more</span> </p>
                        </div>
                        </div>
                        <p class="text-right text-dark font-weight-bolder ctrl-size"><font-awesome-icon class="kova-text ctrl-size" icon="clock" /> 30 minutes ago</p>
                    <hr />
                </div>
                <div class="">
                    <div class="row">
                        <img src="../assets/kovatek/Mask Group 46.svg" alt="" class="rounded-circle img-height" />
                        <div class="col">
                            <h6 class="kova-text text-left font-weight-bolder mt-2">Sun Yeoun W</h6>
                            <p class="text-left text-dark font-weight-lighter mb-0 pb-0 ctrl-size-2">Wordpress login, from username to username email and phone number... <span class="ant-color">see more</span> </p>
                        </div>
                        </div>
                        <p class="text-right text-dark font-weight-bolder ctrl-size"><font-awesome-icon class="kova-text ctrl-size" icon="clock" /> 30 minutes ago</p>
                    <hr />
                </div>
                <div class="">
                    <div class="row">
                        <img src="../assets/kovatek/Mask Group 46.svg" alt="" class="rounded-circle img-height" />
                        <div class="col">
                            <h6 class="kova-text text-left font-weight-bolder mt-2">Sun Yeoun W</h6>
                            <p class="text-left text-dark font-weight-lighter mb-0 pb-0 ctrl-size-2">Wordpress login, from username to username email and phone number... <span class="ant-color">see more</span> </p>
                        </div>
                        </div>
                        <p class="text-right text-dark font-weight-bolder ctrl-size"><font-awesome-icon class="kova-text ctrl-size" icon="clock" /> 30 minutes ago</p>
                    <hr />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'messages'
}
</script>

<style scoped>
.kova-text{
    color: #20409a;
}
.bg-kovatek{
  background-color: #20409A;
}
.add-rounded{
    border-radius: 10px;
}
 .ctrl-size{
     font-size: 11px;
 }
 .ctrl-size-2{
     font-size: 12px;
 }
 .img-height{
        width: 65px;
        height: 65px;
    }

/* total width */

/* set button(top and bottom of the scrollbar) */
.scrollbar::-webkit-scrollbar-button {display:none}

@media screen and (min-width: 992px) and (max-width: 1325px){
    
}

@media screen and (min-width: 992px) and (max-width: 1200px){
    .img-height{
        width: 60px;
        height: 60px;
    }
}

@media screen and (min-width: 768px) and (max-width: 991px){
   
}

@media screen and (max-width: 767px){
    
}
</style>